import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FooterBasicComponent } from '../../components/shared/footer-basic/footer-basic.component';
import { SidebarService } from 'src/app/services';

@Component({
  selector: 'app-secure',
  templateUrl: './secure.component.html',
  styles: [],
})
export class SecureComponent {
  @ViewChild('footer', { static: false }) footer?: FooterBasicComponent;
  constructor(
    public sidebarService: SidebarService,
    private router: Router, 
    @Inject(PLATFORM_ID) private platform: Object) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platform)) {
      this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) return;

        if (evt.url != '/app/dashboard') this.footer.isCollapsed = true;
      });
    }
  }
}
